import { api } from '@/redux/api';
import { useCurrentOrganisation } from './use-current-organisation';
import { useCurrentUnit } from './use-current-unit';

export const useUnitPolicies = () => {
  const { organisation } = useCurrentOrganisation();
  const { data: unit } = useCurrentUnit();

  return api.useGetPoliciesQuery(
    { organisation: organisation!, unitId: unit?.id },
    { skip: organisation === undefined || unit === undefined },
  );
};
